import moment from 'moment';
import { fetchTransactionsByStatus, voteInTransaction } from './../api/api';
import formatUserFeedback, { formatTransactionsShields, checkIfIsNew } from './commonTransactions';

/**
 *
 */
export function transactionDetails() {
  if ($(this).hasClass('no-collapsed-content')) {
    return;
  }

  const $collapsedContent = $(this).siblings('.collapsed-content');
  const $visibleContent = $(this).closest('.transaction-row-container').find('.visible-content');
  const isAnimating = $collapsedContent.is(':animated');

  if (!isAnimating) {
    $collapsedContent.slideToggle(300);
    $visibleContent.toggleClass('expanded');
  }
}

/**
 *
 */
export function transactionCollapse() {
  const $visibleContent = $(this).closest('.transaction-row-container').find('.visible-content');
  const $collapsedContent = $(this).closest('.collapsed-content');
  const isAnimating = $collapsedContent.is(':animated');

  if (!isAnimating) {
    $collapsedContent.slideUp(300);
    $visibleContent.removeClass('expanded');
  }
}

/**
 * @param {Object} event Event object
 */
export async function transactionUserVote(event) {
  event.stopPropagation();
  const responseID = $(this).attr('data-resposta');
  try {
    await voteInTransaction(responseID);
    const $userFeedback = $(this).closest('.user-feedback');

    $userFeedback.find('.vote-success-feedback').addClass('is-active');
    $(this).closest('.transaction-row-container').addClass('already-voted');
  } catch (error) {
    throw error;
  }
}

/**
 * @param {Object} player Player details
 * @param {Object} transactions Player Transactions
 * @returns {string}
 */
export function createHomeTransactionRow(player, transactions) {
  const { saindo, chegando } = transactions;

  return `
    <div class="transaction-row-container">
      <div class="visible-content ${player.text ? '' : 'no-collapsed-content'}">
        <div class="player-details-container">
          <div class="player-image-container">
            <img class="player-image" src="${player.foto}">
          </div>
          <div class="player-details">
            <div class="player-main-details">
              <div class="player-name">${player.nome}
                <span class="player-position-and-tag">
                  <span class="player-position">${player.posicao_sigla}</span>
                  ${checkIfIsNew(chegando, saindo)}
                </span>
              </div>
              <div class="player-update-date">Atualizado ${moment(player.data_ultima_atualizacao).format('DD/MM/YYYY, HH[h]mm')}</div>
            </div>
          </div>
        </div>
        <div class="transaction-shields">
          <div class="origin-teams">
            ${formatTransactionsShields(saindo)}
          </div>
          <div class="destination-teams">
            ${formatTransactionsShields(chegando, true)}
          </div>
        </div>
        <div class="user-feedbacks">
          ${formatUserFeedback(chegando.length ? chegando : saindo)}
        </div>
      </div>
      <div class="collapsed-content">
        <div class="collapsed-content-text">
          ${player.text}
        </div>
        <div class="close-collapsed-content">
          Fechar
          <div class="close-collapsed-content-icon">
            <svg viewBox="0 0 101 101" xmlns="http://www.w3.org/2000/svg">
              <path d="M99.8 19.2C99.6 8.1 91.6.4 80.5.4H19.4c-1.9 0-3.8.2-5.7.8C5.5 3.5.1 10.8.1 20.2v61.1c0 11.1 8 19.3 19.3 19.3h61.9c10.2 0 18.6-8 18.8-18.2-.1-21.2-.1-42.3-.3-63.2zM75.5 71.9l-4.6 4.6c-2.3 2.1-4.6 2.1-6.7 0L51.6 63.9l-1.7-1.7-7.9 7.9-6.5 6.5c-2.1 2.1-4.4 2.1-6.5 0l-5-5c-2.3-2.3-2.3-4.6 0-6.9l13.8-13.8s0-.2.2-.4L36.5 49c-4.2-4.2-8.2-8.2-12.3-12.5-2.5-2.5-2.5-4.8 0-7.5 1.3-1.5 2.9-2.9 4.4-4.4 2.7-2.7 4.8-2.7 7.5.2l13.8 13.8 1.7-1.7 12.6-12.6c2.3-2.3 4.6-2.3 7.1 0 1.7 1.5 3.3 3.3 5 5 2.1 2.3 2.3 4.6 0 6.7L63.7 48.6 62 50.3l13.6 13.6c2.8 3 2.8 5.1-.1 8z" fill="currentColor"/>
            </svg>
          </div>
        </div>
        <a href="${player.url}" target="_blank" class="collapsed-read-more">
          Ler mais
          <div class="collapsed-read-more-icon">
            <svg viewBox="0 0 159 119" xmlns="http://www.w3.org/2000/svg">
              <path d="M89 79.9H10.3c-8.5 0-9.4-.9-9.4-9.5V48.9c0-8.1.9-9 8.8-9h79.2v-5.5c0-9.3-.2-18.7.1-28 .1-2 1.3-4.8 2.9-5.6C93.4 0 96.6.7 98 2c19.6 17.6 39 35.4 58.4 53.1 3.3 3 3 5.9-.2 8.9-19.3 17.7-38.4 35.5-57.8 53-1.5 1.4-4.8 2.5-6.4 1.7-1.6-.7-2.9-3.9-2.9-6-.2-10.5-.1-21.4-.1-32.8z" fill="currentColor"/>
            </svg>
          </div>
        </a>
      </div>
    </div>
  `;
}

/**
 *
 */
export async function viewMoreTransactions() {
  if ($(this).hasClass('is-hidden')) {
    return;
  }

  const statusID = $(this).attr('data-status-id');
  const statusCurrentPage = $(this).attr('data-page');
  const nextPage = Number(statusCurrentPage) + 1;
  const $loading = $(this).siblings('.loading-data').find('.loading-outer-container');

  $(this).addClass('is-disabled');
  $loading.addClass('is-visible');

  try {
    const { status, paginator } = await fetchTransactionsByStatus(statusID, nextPage);
    const { pagina, paginas } = paginator;
    const isLastPage = Number(pagina) === Number(paginas);

    if (isLastPage) {
      $(this).addClass('is-hidden');
    }
    $loading.removeClass('is-visible');
    $(this).removeClass('is-disabled');
    $(this).attr('data-page', nextPage);

    status.forEach((singleStatus) => {
      const { atleta, transacoes } = singleStatus;
      const $currentStatus = $(`.status-outer-container[data-status-id="${statusID}"]`);
      const $statusTransactionsList = $currentStatus.find('.transactions');
      $statusTransactionsList.append(createHomeTransactionRow(atleta, transacoes));
    });
    $('.tabs-content')[0].slick.setPosition();
  } catch (error) {
    console.log('Aconteceu um erro no servidor, tente novamente', error);
  }
}



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/components/homeTransaction.js